export default __webpack_public_path__ + "static/media/ie.5b40db52.svg";